import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RecurringTotalComponent} from './recurring-total.component';
import {I18nModule} from '@spartacus/core';


@NgModule({
  declarations: [
    RecurringTotalComponent
  ],
  imports: [
    CommonModule,
    I18nModule
  ],
  exports: [
    RecurringTotalComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ]
})
export class RecurringTotalModule {
}
